import React from "react"
import Link from "gatsby-link"

class Footer extends React.Component {
  render() {
    return (
      <footer>
        <div className="container footer-container">
          <div>
            <p style={{ marginBottom: 0 }}>© 2019 Nathan Gaw</p>
            <p>Trading as Spyke Digital Ltd. // 07469745</p>
            <p>
              Find me on <a href="https://www.twine.fm/nathangaw">Twine</a>
            </p>
          </div>
          <div>
            <p>Freelance website designer/developer based in Hampshire, UK.</p>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js